export const SUCCESS_CODES = "SUCCESS_CODES";
export const SUCCESS_DELETE_CODE = "SUCCESS_DELETE_CODE";
export const GENERATED_CODE = "GENERATED_CODE";